import Image from "@/atoms-react/image/Image.react";
import "../index.css";

export const LoginSpaceshipAnimation = ({ className }: { className?: string }) => (
  <div className={className}>
    <div className="absolute top-0 right-0 left-0 z-10 mx-auto h-full w-full max-w-3xl animate-float">
      <Image
        src="/images/olkypass/signup-illustration/spaceship.svg"
        className={"absolute top-0 right-0 left-0 z-10 mx-auto h-full w-full max-w-3xl"}
        alt="Spaceship"
      />
      <Image
        src="/images/olkypass/signup-illustration/light.svg"
        className={
          "absolute top-0 right-0 left-0 z-10 mx-auto h-full w-full max-w-3xl animate-heavy-pulse"
        }
        alt="Spaceship"
      />
    </div>
    <Image
      src="/images/olkypass/signup-illustration/planets.png"
      className={"absolute top-0 right-0 left-0 z-10 mx-auto h-full w-full max-w-3xl"}
      alt="Planets"
    />
  </div>
);
